import { createRouter, createWebHistory } from "vue-router"
import Home from "../views/Home.vue"
import Login from "../views/auth/Login.vue"
import Signup from "../views/auth/Signup.vue"
// import Admin from "../views/Admin.vue"
import Dashboard from "../views/Dashboard.vue"

import Hangman from "../views/Hangman.vue"

// TodoList
import TodoList from "../views/TodoList.vue"
import CreateTodolists from "../views/todolist/CreateTodolists.vue"
import TodolistDetails from "../views/todolist/TodolistDetails.vue"
import UserTodolists from "../views/todolist/UserTodolists.vue"
import ListTag from "../views/todolist/ListTag.vue"

// Blog

import Post from "../views/Post.vue"
import CreatePosts from "../views/posts/CreatePosts.vue"
import PostDetails from "../views/posts/PostDetails.vue"
import UserPosts from "../views/posts/UserPosts.vue"
import PostTag from "../views/posts/PostTag.vue"

// Note
// import CreateNotes from "../views/notes/CreateNotes.vue"
// import NoteDetails from "../views/notes/NoteDetails.vue"
// import UserNotes from "../views/notes/UserNotes.vue"
// import NoteTag from "../views/notes/NoteTag.vue"

// route guard
import { projectAuth } from "../firebase/config"

const requireAuth = (to, from, next) => {
  let user = projectAuth.currentUser
  if (!user) {
    next({ name: "Login" })
  } else {
    next()
  }
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    // beforeEnter: requireAuth,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  // {
  //   path: "/admin",
  //   name: "Admin",
  //   component: Admin,
  //   beforeEnter: requireAuth,
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: requireAuth,
  },
  {
    path: "/hangman",
    name: "Hangman",
    component: Hangman,
    beforeEnter: requireAuth,
  },

  // Todolists
  {
    path: "/todolist",
    name: "TodoList",
    component: TodoList,
    beforeEnter: requireAuth,
  },
  {
    path: "/todolist/create",
    name: "CreateTodolists",
    component: CreateTodolists,
    beforeEnter: requireAuth,
  },
  {
    path: "/todolist/:id",
    name: "TodolistDetails",
    component: TodolistDetails,
    props: true,
    beforeEnter: requireAuth,
  },
  {
    path: "/todolist/user",
    name: "UserTodolists",
    component: UserTodolists,
    beforeEnter: requireAuth,
  },
  {
    path: "/todolists/listtags/:tag",
    name: "ListTag",
    component: ListTag,
    beforeEnter: requireAuth,
  },

  // Post
  {
    path: "/post",
    name: "Post",
    component: Post,
    beforeEnter: requireAuth,
  },
  {
    path: "/posts/create",
    name: "CreatePosts",
    component: CreatePosts,
    beforeEnter: requireAuth,
  },
  {
    path: "/posts/:id",
    name: "PostDetails",
    component: PostDetails,
    props: true,
    beforeEnter: requireAuth,
  },
  {
    path: "/posts/user",
    name: "UserPosts",
    component: UserPosts,
    beforeEnter: requireAuth,
  },
  {
    path: "/posts/posttags/:tag",
    name: "PostTag",
    component: PostTag,
    beforeEnter: requireAuth,
  },

  // Note
  // {
  //   path: "/notes/create",
  //   name: "CreateNotes",
  //   component: CreateNotes,
  //   beforeEnter: requireAuth,
  // },

  // {
  //   path: "/notes/:id",
  //   name: "NoteDetails",
  //   component: NoteDetails,
  //   props: true,
  //   beforeEnter: requireAuth,
  // },
  // {
  //   path: "/notes/user",
  //   name: "UserNotes",
  //   component: UserNotes,
  //   beforeEnter: requireAuth,
  // },
  // {
  //   path: "/notes/notetags/:tag",
  //   name: "NoteTag",
  //   component: NoteTag,
  //   beforeEnter: requireAuth,
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
